module.exports = __webpack_public_path__ + "static/media/event.89f95456.webp";